module.exports = __webpack_public_path__ + "media/images/icons/outlined/instagram-554f7564ccbea73d421fcd9322bd5fb4.svg";